import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { QueryClient } from "./lib/ReactQuery/QueryClient";
import { reloadOnStaleChunk } from "./lib/Utils/reloadOnStaleChunk";

declare global {
  interface Window {
    __isUnloading?: boolean;
  }
}

// Set unloading flag as early as possible to suppress aborted request errors
window.addEventListener("pagehide", () => {
  window.__isUnloading = true;
});
window.addEventListener("beforeunload", () => {
  window.__isUnloading = true;
});

// Safari bfcache: invalidate all queries when page is restored from cache
// This prevents stale data from being displayed after back/forward navigation
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    console.log("[bfcache] Page restored from cache, invalidating queries");
    window.__isUnloading = false;
    QueryClient.invalidateQueries();
  }
});

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  reloadOnStaleChunk(event.payload);
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
